var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"story-background",style:({ width: _vm.imageWidth + 'px', height: _vm.imageHeight + 'px' })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('span',[_vm._v("+")]),_c('span',[_vm._v("Загрузить")])])
}]

export { render, staticRenderFns }